import classes     from "./Analys.module.scss"
import Cards       from './../../../Cards/Cards';
import AccentTitle from './../AccentTitle/AccentTitle';
import Image       from './../../../Image/Image';

import graph       from "./../../../Assets/Img/Src/SecondStep/graph2.jpg"
import graphWebp   from "./../../../Assets/Img/Webp/SecondStep/graph2.webp"

import graph2      from "./../../../Assets/Img/Src/SecondStep/graph3.jpg"
import graph2Webp  from "./../../../Assets/Img/Src/SecondStep/graph3.jpg"

import kpi         from "./../../../Assets/Img/Src/SecondStep/KPI.jpg"
import kpiWebp     from "./../../../Assets/Img/Webp/SecondStep/KPI.webp"



import CardsHorizontal from './CardsHorizontal/CardsHorizontal';

const Analys = () => {
   return (
     <div className={classes.Analys}>
       
       <AccentTitle number="02." title="Аналитика" customClass={classes.Title}/>
      <div className={classes.Content}>
       <CardsHorizontal
        num={"a."}
        CustomDescription={classes.RightSide}
        title={"В начале работы мы установили на сайт 26 целей."}
        text={"Данные по этим целям помогли на базе собранной статистики лучше понять поведение пользователей и лучше понять их потребности. Данные, полученные с помощью этих целей в 2016 году, привели к такому количеству правок сайта, что Заказчик принял решение создать новый сайт. Именно эти данные, собранные в рамках нашего анализа легли в основу разработки конверсионных элементов нового сайта. Вся проведенная аналитическая работа, впоследствии привела к росту конверсии на новом сайте на 3%."}
        textSecond={"В рамках аналитических изысканий каждые несколько месяцев мы производили различные статистические исследования, направленные на определение точек приложения усилий."}
       />
        <div className={classes.ScrollWrap}>
          <div className={classes.Image}>
            <Image src={graph} srcWebp={graphWebp}/>
          </div>
        </div>
        <div className={classes.ScrollWrap}>
          <div className={classes.Image}>
            <Image src={graph2} srcWebp={graph2Webp}/>
          </div>
        </div>
        </div>
        <CardsHorizontal
          num={"b."}
          title={"Определение основных KPI и агрегация данных по ним."}
          text={"Кроме позиций поисковых запросов мы ориентировались на рост трафика и на получение заказчиком ЛИДов, которые бы максимально конвертировались в заказы. Для отслеживания всех этих параметров и понимания взаимосвязи между ними, после общения с Заказчиком была разработана архитектура взаимосвязи параметров между собой, внесены необходимые коэффициенты сезонности и сформирована итоговая таблица, позволявшая оценивать картину за большие и малые периоды времени в разных срезах."}
          textSecond={"Все время нашей работы мы контролировали не только трафик, но и параметры его качества, которые непосредственно влияют на конверсию. Конверсия росла медленно и в 2020 году достигла пика. Как видно из примера ниже, в июле и августе 2020 года эффективность сайта достигла своего пика в 5%. Этот показатель более чем в 2 раза выше, чем в 2019 году и в 3 раза выше чем в годы ранее. Показатель конверсии считался исключительно по поисковому трафику. И это при том, что продается дорогой и очень сложный товар."}
          customHorizontalClass={classes.HorizonalSecond}
          CustomDescription={classes.HorisontalSecondRightSide}
       />
       <div className={classes.ScrollWrap}>
          <div className={classes.Image}>
            <Image src={kpi} srcWebp={kpiWebp}/>
          </div>
        </div>  
    </div>
   )
}
export default Analys;